module.exports = __webpack_public_path__ + "img/google-play.48ad4e75.png";